import { render, staticRenderFns } from "./ConfirmDeleteChallengeModal.vue?vue&type=template&id=2f82f98a"
import script from "./ConfirmDeleteChallengeModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteChallengeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
